export const bacteriaLayoutConfig_allergy_kids_eng = [

    // Harmful Bacteria
    {
        label: 'Ruminococcus bromii',
        page: 12,
        yOffset: 392,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 384,
        yResult: 384,
        yResulttext: 388,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 12,
        yOffset: 226,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 220,
        yResult: 220,
        yResulttext: 223,
        xResulttext: 570,  
        show_result: true
    },
    // Core Bacteria
    {
        label: 'Bacteroidetes phylum',
        page: 12,
        yOffset: 312,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 304,
        yResult: 304,
        yResulttext: 308,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Clostridium cluster IV',
        page: 12,
        yOffset: 352,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 344,
        yResult: 344,
        yResulttext: 348,
        xResulttext: 570,  
        show_result: true
    },
    // Probiotics
    {
        label: 'Bifidobacterium bifidum',
        page: 12,
        yOffset: 471,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 465,
        yResult: 464,
        yResulttext: 467,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 12,
        yOffset: 509,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 503,
        yResult: 503,
        yResulttext: 505,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 12,
        yOffset: 547,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 541,
        yResult: 541,
        yResulttext: 543,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 12,
        yOffset: 585,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 579,
        yResult: 579,
        yResulttext: 581,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus plantarum',
        page: 12,
        yOffset: 624,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 618,
        yResult: 618,
        yResulttext: 620,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 12,
        yOffset: 662,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 656,
        yResult: 656,
        yResulttext: 658,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Ruminococcus bromii',
        page: 16,
        yOffset: 923,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 917,
        yResult: 917,
        yResulttext: 919,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Staphylococcus aureus',
        page: 16,
        yOffset: 144,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 138,
        yResult: 138,
        yResulttext: 140,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Bacteroidetes phylum',
        page: 16,
        yOffset: 428,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 422,
        yResult: 422,
        yResulttext: 424,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Clostridium cluster IV',
        page: 16,
        yOffset: 731,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 725,
        yResult: 725,
        yResulttext: 727,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 17,
        yOffset: 141,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 135,
        yResult: 141,
        yResulttext: 137,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 17,
        yOffset: 306,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 300,
        yResult: 503,
        yResulttext: 302,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 17,
        yOffset: 538,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 532,
        yResult: 541,
        yResulttext: 534,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus paracasei',
        page: 17,
        yOffset: 749,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 743,
        yResult: 579,
        yResulttext: 745,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus plantarum',
        page: 18,
        yOffset: 98,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 92,
        yResult: 618,
        yResulttext: 94,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 18,
        yOffset: 376,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 370,
        yResult: 656,
        yResulttext: 372,
        xResulttext: 570,  
        show_result: false
    },
];

export const bacteriaLayoutConfig_allergy_kids_thai = [
        // Harmful Bacteria
        {
            label: 'Ruminococcus bromii',
            page: 11,
            yOffset: 392,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 384,
            yResult: 384,
            yResulttext: 388,
            xResulttext: 570,  
            show_result: true
        },
        {
            label: 'Staphylococcus aureus',
            page: 11,
            yOffset: 226,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 220,
            yResult: 220,
            yResulttext: 223,
            xResulttext: 570,  
            show_result: true
        },
        // Core Bacteria
        {
            label: 'Bacteroidetes phylum',
            page: 11,
            yOffset: 312,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 304,
            yResult: 304,
            yResulttext: 308,
            xResulttext: 570,  
            show_result: true
        },
        {
            label: 'Clostridium cluster IV',
            page: 11,
            yOffset: 352,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 344,
            yResult: 344,
            yResulttext: 348,
            xResulttext: 570,  
            show_result: true
        },
        // Probiotics
        {
            label: 'Bifidobacterium bifidum',
            page: 11,
            yOffset: 471,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 465,
            yResult: 464,
            yResulttext: 467,
            xResulttext: 570,  
            show_result: true
        },
        {
            label: 'Bifidobacterium longum',
            page: 11,
            yOffset: 509,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 503,
            yResult: 503,
            yResulttext: 505,
            xResulttext: 570,  
            show_result: true
        },
        {
            label: 'Lactobacillus acidophilus',
            page: 11,
            yOffset: 547,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 541,
            yResult: 541,
            yResulttext: 543,
            xResulttext: 570,  
            show_result: true
        },
        {
            label: 'Lactobacillus paracasei',
            page: 11,
            yOffset: 585,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 579,
            yResult: 579,
            yResulttext: 581,
            xResulttext: 570,  
            show_result: true
        },
        {
            label: 'Lactobacillus plantarum',
            page: 11,
            yOffset: 624,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 618,
            yResult: 618,
            yResulttext: 620,
            xResulttext: 570,  
            show_result: true
        },
        {
            label: 'Lactobacillus rhamnosus',
            page: 11,
            yOffset: 662,
            xLabel: 70,
            xBarStart: 295,
            xBarGap: 53,
            xResult: 685,
            yLabel: 656,
            yResult: 656,
            yResulttext: 658,
            xResulttext: 570,  
            show_result: true
        },

    // Harmful Bacteria
    {
        label: 'Ruminococcus bromii',
        page: 15,
        yOffset: 968,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 962,
        yResult: 962,
        yResulttext: 964,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Staphylococcus aureus',
        page: 15,
        yOffset: 148,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 140,
        yResult: 140,
        yResulttext: 142,
        xResulttext: 570,  
        show_result: false
    },

    // Core Bacteria
    // {
    //     label: 'Bacteroidetes phylum',
    //     page: 11,
    //     yOffset: 375,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 367,
    //     yResult: 364,
    //     yResulttext: 368,
    //     xResulttext: 570,  
    //     show_result: true
    // },
    {
        label: 'Bacteroidetes phylum',
        page: 15,
        yOffset: 408,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 400,
        yResult: 400,
        yResulttext: 402,
        xResulttext: 570,  
        show_result: false
    },
    // {
    //     label: 'Clostridium cluster IV',
    //     page: 11,
    //     yOffset: 415,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 407,
    //     yResult: 407,
    //     yResulttext: 409,
    //     xResulttext: 570,  
    //     show_result: true
    // },
    {
        label: 'Clostridium cluster IV',
        page: 15,
        yOffset: 690,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 682,
        yResult: 683,
        yResulttext: 683,
        xResulttext: 570,  
        show_result: false
    },
    // Probiotics
    // {
    //     label: 'Bifidobacterium bifidum',
    //     page: 11,
    //     yOffset: 518,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 510,
    //     yResult: 510,
    //     yResulttext: 512,
    //     xResulttext: 570,  
    //     show_result: true
    // },
    {
        label: 'Bifidobacterium bifidum',
        page: 16,
        yOffset: 143,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 135,
        yResult: 510,
        yResulttext: 137,
        xResulttext: 570,  
        show_result: false
    },
    // {
    //     label: 'Bifidobacterium longum',
    //     page: 11,
    //     yOffset: 558,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 550,
    //     yResult: 550,
    //     yResulttext: 552,
    //     xResulttext: 570,  
    //     show_result: true
    // },
    {
        label: 'Bifidobacterium longum',
        page: 16,
        yOffset: 290,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 282,
        yResult: 550,
        yResulttext: 284,
        xResulttext: 570,  
        show_result: false
    },
    // {
    //     label: 'Lactobacillus acidophilus',
    //     page: 11,
    //     yOffset: 598,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 590,
    //     yResult: 590,
    //     yResulttext: 592,
    //     xResulttext: 570,  
    //     show_result: true
    // },
    {
        label: 'Lactobacillus acidophilus',
        page: 16,
        yOffset: 502,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 494,
        yResult: 590,
        yResulttext: 496,
        xResulttext: 570,  
        show_result: false
    },
    // {
    //     label: 'Lactobacillus paracasei',
    //     page: 11,
    //     yOffset: 638,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 630,
    //     yResult: 630,
    //     yResulttext: 632,
    //     xResulttext: 570,  
    //     show_result: true
    // },
    {
        label: 'Lactobacillus paracasei',
        page: 16,
        yOffset: 670,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 662,
        yResult: 630,
        yResulttext: 664,
        xResulttext: 570,  
        show_result: false
    },
    // {
    //     label: 'Lactobacillus plantarum',
    //     page: 11,
    //     yOffset: 678,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 670,
    //     yResult: 670,
    //     yResulttext: 672,
    //     xResulttext: 570,  
    //     show_result: true
    // },
    {
        label: 'Lactobacillus plantarum',
        page: 17,
        yOffset: 108,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 100,
        yResult: 670,
        yResulttext: 102,
        xResulttext: 570,  
        show_result: false
    },
    // {
    //     label: 'Lactobacillus rhamnosus',
    //     page: 11,
    //     yOffset: 718,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 710,
    //     yResult: 710,
    //     yResulttext: 712,
    //     xResulttext: 570,  
    //     show_result: true
    // },
    {
        label: 'Lactobacillus rhamnosus',
        page: 17,
        yOffset: 388,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 380,
        yResult: 710,
        yResulttext: 382,
        xResulttext: 570,  
        show_result: false
    },
];